export default __webpack_public_path__ + "assets/images/active.796511.avif";